<script>
  import {
    VAppBar
  } from 'vuetify/lib'
  export default {
    name: 'wh-topbar',
    extends: VAppBar
  };
</script>